module.exports = __webpack_public_path__ + "static/dev-a57ad7802cadc1330bc9d59e867f5cbb.svg";